<template>
  <div style="margin-left: 10px; margin-right: 10px">
    <v-overlay v-if="loading">Cargando Documento </v-overlay>
    <v-row>
      <v-col md="12" cols="12">
        <v-card>
          <v-card-title>Documento de Salida de inventarios</v-card-title>
          <v-btn
            @click="goRoute('/productos-inventarios/salidas')"
            text
            color="red"
          >
            <i style="color: red" class="lni lni-chevron-left"></i> Regresar a
            documentos
          </v-btn>
          <v-btn
            @click="
              verifySelectedOrigen(() => {
                formExistKey++;
                showModalExist = true;
                newLoadData = false;
              })
            "
            v-if="!Aplicado"
            text
            color="primary"
          >
            <i class="lni lni-plus"></i> Salida de producto existente
          </v-btn>

          <v-btn @click="guardar()" v-if="!Aplicado" text color="green">
            <i class="lni lni-save"></i> Guardar
          </v-btn>

          <v-btn
            @click="saveSend()"
            v-if="!Aplicado && this.$route.params.idDocumento"
            text
            color="green"
          >
            <i class="lni lni-save"></i> Dar Salida a inventario
          </v-btn>

          <v-card-text>
            <v-row>
              <!-- <v-col md="4">
                <v-text-field
                  v-on:keyup.enter="searchProducts()"
                  v-model="code"
                  label="Escanea o escribe el codigo del producto"
                ></v-text-field>
              </v-col>
              <v-col md="2">
                <v-btn color="primary" @click="searchProducts"> Buscar </v-btn>
              </v-col> -->
              <v-col md="12">
                <v-autocomplete
                  :items="origenes"
                  item-value="id"
                  item-text="Nombre"
                  v-model="Origen"
                  label="Almacen"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="12">
        <uv-data-table
          :config="config"
          :data="productsDocument"
          :pageRows="30"
          @buttonClick="dtButtonClick"
          @buttonOptClick="optButtonClick"
        ></uv-data-table>
      </v-col>
    </v-row>
    <modal
      v-model="showModal"
      :showFooter="false"
      title="Agregar Producto Nuevo"
    >
      <productoForm
        :loadData="newLoadData"
        :key="formKey"
        @toggle="toggleModal"
        @successData="saveProduct"
      ></productoForm>
    </modal>
    <modal
      v-model="showModalExist"
      :showFooter="false"
      title="Salida de producto existente"
    >
      <productoExistForm
        :loadData="newLoadData"
        :key="formExistKey"
        :Origen="Origen"
        @toggle="showModalExist = false"
        @successData="saveExistProduct"
      ></productoExistForm>
    </modal>
    <modal
      v-model="showModalFactura"
      :showFooter="false"
      title="Agregar Numero de Factura"
    >
      <productoFacturaForm
        :key="formFacturaKey"
        @toggle="showModalFactura = false"
        :ids="idsSelected"
        @successData="successFactura"
      ></productoFacturaForm>
    </modal>
  </div>
</template>

<style>
.menubtn {
  display: none;
}
</style>

<script>
import moment from "moment";
import modal from "../../MainComponents/modal.vue";
import uvDataTable from "../../MainComponents/DataTable.vue";
import productoForm from "../RecepcionMercancias/ProductAddForm.vue";
import productoExistForm from "../SalidaMercancias/ProductExistFormSalida.vue";
import productoFacturaForm from "../RecepcionMercancias/ProductNumeroFacturaForm.vue";
import SalidasInventario from "../../../clases/PdfMakers/DocumentosSalidas";
import pdfmake from "pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfmake.vfs = pdfFonts.pdfMake.vfs;
export default {
  name: "DocumentoSalidasCreator",
  components: {
    modal,
    uvDataTable,
    productoForm,
    productoExistForm,
    productoFacturaForm,
  },
  props: [],
  data() {
    return {
      MainDepartamento: "",
      appName: process.env.VUE_APP_NAME,
      Origen: "",
      loading: false,
      Aplicado: false,
      self: this,
      code: "",
      showModal: false,
      showModalExist: false,
      showModalFactura: false,
      formKey: 0,
      formExistKey: 0,
      newLoadData: false,
      formFacturaKey: 0,
      idsSelected: [],
      productsDocument: [],
      formIndex: 0,
      editMode: false,
      editData: [],
      hoteles: [],
      usuarios: [],
      editedHotel: {},

      config: {
        selectableRow: true,
        orderByCol: { Field: "Nombre", Type: "Asc" },
        selectConfig: {
          multiSelect: true,
          idRowData: "internalId", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        buttons: [
          {
            text: "Eliminar",
            icon: "lni lni-trash",
            buttonId: "deleteDocumentProduct",
            require: true,
            limitRequire: 1,
          },
          {
            text: "Exportar pdf",
            icon: "lni lni-download",
            buttonId: "docsToPdf",
          },
        ],
        fields: [
          {
            value: "Nombre",
            text: "Nombre",
          },
          {
            value: "Cantidad",
            text: "Cantidad",
            format: (row) => {
              return this.$pgsHelper.formatNumber(row["Cantidad"]);
            },
          },
          {
            value: "motivoNombre",
            text: "Motivo",
          },
        ],
      },
    };
  },
  methods: {
    async getOrigenes() {
      var data = await this.$store.getters.getFirebaseApp.database
        .ref("PDV/Inventario/Origenes")
        .once("value");
      let arrayOrg = Object.entries(data.val());
      let origenes = [];
      arrayOrg.forEach((element) => {
        if (!this.$route.params.idDocumento) {
          this.Origen = element[0];
        }
        origenes.push({
          id: element[0],
          Nombre: element[1]["Nombre"],
          Departamentos: element[1]["Departamentos"],
        });
      });

      this.origenes = origenes;
    },
    verifySelectedOrigen(callback) {
      if (this.Origen == "") {
        this.$swal("Seleccione un centro de consumo", "", "error");
        return false;
      }
      {
        callback();
      }

      return true;
    },
    goRoute(routePath) {
      this.$router.push({ path: routePath });
    },
    dtButtonClick(buttonId, idSelected) {
      if (buttonId == "docsToPdf") {
        this.generatePdf();
      } else if (this.Aplicado) {
        this.$swal(
          "No puedes modificar un documento aplicado a inventario",
          "",
          "error"
        );
        return false;
      }

      if (buttonId == "modificarFactura") {
        // Buscar el producto usando internalId y extraer su id real
        const producto = this.productsDocument.find(
          (item) => item.internalId === idSelected[0]
        );
        if (!producto) {
          return;
        }

        this.formFacturaKey++;
        this.idsSelected = producto.id;
        this.showModalFactura = true;
      }

      if (buttonId == "deleteDocumentProduct") {
        this.deleteItem(idSelected[0]);
      }
    },

    optButtonClick(buttonId, ref) {
      if (buttonId == "editPrice") {
        this.editedHotel = this.getHotelinfoById(ref);
        this.toggleModal(true);
      }
    },

    async generatePdf() {
      let prod = this.$store.getters.getProductos;
      // let origenes = this.$store.getters.getOrigenes;

      // const origen = this.$pgsHelper.getById(origenes, "Origen", this.Origen);

      const productsToPdf = this.productsDocument.map((doc) => {
        
        const productoData = this.$pgsHelper.getById(prod, "id", doc.id);

        return {
          ...doc,
          Unidad: productoData?.UnidadMedida || "PZA",
        };
      });

      let mainData = {
        TITLE: "Salida de Mercancias - " + this.$route.params.idDocumento,
        FG: new moment().format("DD/MM/YYYY"),
        HG: new moment().format("HH:mm:ss"),
        dep: this.MainDepartamento,
        data: productsToPdf,
      };
      let docData = SalidasInventario.getDocData(mainData);
      pdfmake.createPdf(docData).open();
    },

    getCategoryById(code) {
      let itemIndex = this.$_.findIndex(this.Categories, { id: code });
      if (itemIndex >= 0) {
        return this.Categories[itemIndex];
      }

      return false;
    },
    deleteItem(id) {
      // this.$swal({
      //   title: "¿Deseas eliminar este producto del documento?",
      //   text: "Los cambios se veran reflejados hasta realizar el guardado ",
      //   icon: "warning",
      //   allowOutsideClick: false,
      //   showCancelButton: true,
      //   confirmButtonColor: "#3085d6",
      //   cancelButtonColor: "#d33",
      //   confirmButtonText: "Eliminar",
      //   showLoaderOnConfirm: true,
      // }).then((result) => {
      //   if (result.value) {

      //     this.$swal({
      //       title: "Eliminado",
      //       text: "El producto se elimino corretamente",
      //       icon: "success",
      //     });
      //   }
      // });
      this.productsDocument.forEach((element, index) => {
        if (element.internalId == id) {
          this.productsDocument.splice(index, 1);
        }
      });
    },
    saveExistProduct(datos) {
      this.$pgsHelper.log(datos);
      if (this.productsDocument.length > 450) {
        this.$swal(
          "No puedes agregar mas de 450 productos al documento",
          "",
          "error"
        );
        return false;
      }
      const newId = datos.producto + "/" + datos.motivoNombre;
      const productAlreadyExists = this.$pgsHelper.getById(
        this.productsDocument,
        "id",
        newId
      );
      if (productAlreadyExists) {
        productAlreadyExists.Cantidad += datos.cantidad;
      } else {
        this.productsDocument.push({
          internalId: newId,
          id: datos.producto,
          Nombre: datos.nombre,
          motivoNombre: datos.motivoNombre,
          Motivo: { Id: datos.motivo, Nombre: datos.motivoNombre },
          Cantidad: datos.cantidad,
          Notas: "",
          Precio: datos.newPrice,
          Moneda: datos.actualMoneda,
          Codigo: datos.codigo,
        });
      }
      this.showModalExist = false;
    },
    successData(data, doAction) {
      if (doAction == "CREATE") {
        alert("Creando");
        this.$pgsHelper.log(data);
      } else if (doAction == "EDIT") {
        alert("editando");
        this.$pgsHelper.log(data);
      }
    },
    saveProduct(datos) {
      datos.Precio = parseFloat(datos.Precio);
      datos.Existencia = parseInt(datos.Existencia);
      datos.Alerta = parseInt(datos.Alerta);
      datos.Departamentos = [datos.Departamento];
      datos.FechaCreacion = new moment().format("YYYY-MM-DD");
      datos.Departamento = this.MainDepartamento;
      this.$swal({
        title: "¿Deseas crear este nuevo producto?",
        text: "Se registrar el producto y se agregara una entrada de inventario en este documento",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar!",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("RVA-Catalogo-CrearCatalogoItem", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal({
              title: "Guardado",
              text: "La categoria se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.toggleModal(false);
              this.$swal({
                title: "Agregando entrada de inventario",
                text: "",
                icon: "",
                onBeforeOpen: () => {
                  this.$swal.showLoading();
                },
              });

              this.$swal.close();
              this.$swal({
                title: "Entrada de producto almacenada correctamente",
                text: "Se registro una entrada de producto previo a inventario",
                icon: "success",
              }).then(() => {
                this.toggleModal(false);
                //this.getCategories();
              });
            });
          } else {
            this.$swal(
              "Error saving Categoria",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    successFactura(data) {
      data.idRow.forEach((element) => {
        this.productsDocument.forEach((prod) => {
          if (prod.id == element) {
            prod.Factura = data.n_factura;
          }
        });
      });

      this.showModalFactura = false;

      this.$swal({
        title: "Numero de factura modificado",
        text: "Los productos seleccionados cambiaron su numero de factura",
        icon: "success",
      });
    },
    toggleModal(open) {
      this.showModal = open;
    },
    async searchProducts() {
      this.newLoadData = false;
      this.$swal({
        title: "Buscando Productos",
        text: "",
        icon: "",
        onBeforeOpen: () => {
          this.$swal.showLoading();
        },
      });
      //this.code = "691316727252";
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      var data = await firestore.queryBuilder("PDV_Productos", [
        firestore.where("CodigoBarras", "==", this.code),
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
      ]);

      //this.$pgsHelper.log(data.docs.map(doc=>{return {id:doc.ref.id,...doc.data()}}));
      let products = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });
      if (products.length > 0) {
        this.formExistKey++;
        this.newLoadData = { ProductoId: products[0].id };
        this.showModalExist = true;
      } else {
        this.$swal({
          title: "El producto no se encuentra registrado",
          text: "El producto escaneado no se encuentra regitrado en el sistema",
          icon: "error",
        });
      }
      this.$swal.close();
    },
    async getDocumentInfo(id) {
      this.loading = true;
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      const doc = firestore.doc("PDV_Prod_EntSal/", id);
      const data = await firestore.getDoc(doc);

      let document = { id: data.ref.id, ...data.data() };
      this.Origen = document.Origen;
      this.Aplicado = document.Aplicado;
      let productos = Object.entries(document.Productos);
      productos.forEach((element) => {
        let datos = element[1];

        const internalId = datos.Id + "/" + datos.Motivo.Nombre;
        this.productsDocument.push({
          Cantidad: datos.Cantidad,
          internalId: internalId,
          id: datos.Id,
          Motivo: datos.Motivo,
          MotivoId: datos.Motivo.Id,
          motivoNombre: datos.Motivo.Nombre,
          Nombre: datos.Nombre,
        });
      });
      this.loading = false;
    },
    guardar(sendInv = false) {
      if (this.Origen == "") {
        this.$swal(
          "Seleccione un centro de consumo",
          "Para continuar por favor indique el centro de consumo el que saldran los productos",
          "error"
        );
        return false;
      }
      let data = {
        Productos: [],
        TipoMovimiento: "Salida",
        FechaMovimiento: new moment().format("YYYY-MM-DD"),
        Origen: this.Origen,
      };
      this.productsDocument.forEach((element) => {
        data.Productos.push({
          internalId: element.internalId,
          Id: element.id,
          Nombre: element.Nombre,
          Factura: element.Factura,
          Cantidad: parseInt(element.Cantidad),
          Precio: parseFloat(element.Precio),
          Moneda: element.Moneda,
          Motivo: element.Motivo,
        });
      });

      if (this.$route.params.idDocumento) {
        this.editDocument(data, sendInv);
      } else {
        this.saveDocument(data, sendInv);
      }
    },
    saveSend() {
      this.guardar(true);
    },
    sendInventario() {
      let datos = {
        Id: this.$route.params.idDocumento,
        TipoMovimiento: "Salida",
      };
      this.$swal({
        title: "¿Deseas afectar el inventario con los productos indicados?",
        text: " El documento sera enviado a inventario ",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("ProShop-Inventario-aplicarPreInventario", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$pgsHelper.writeLog({
              Evento: "INVENTARIO_SALIDA_APLICAR",
              Mensaje: `Salida de inventario aplicada a stock: ${datos.id || datos.Folio || ""}`.trim(),
              reference: { id: datos.id, tp: "INV-SalidaMercancia", al: datos.Folio || "SALIDA INVENTARIO" },
              data: datos
            });
            this.$swal({
              title: "Guardado",
              text: "El documento se envio a inventario corretamente",
              icon: "success",
            });

            this.Aplicado = true;
          } else {
            this.$swal(
              "Error aplicando inventario",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    saveDocument(datos, sendInv) {
      this.$pgsHelper.log(datos);
      this.$swal({
        title:
          "¿Deseas crear este nuevo documento de salida con los productos indicados?",
        text: "Se registrar el documento y sus productos indicados ",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("ProShop-Inventario-crearPreInventario", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            const targetId = result.value.data.data?.Id || result.value.data.id || datos.Id;
            this.$pgsHelper.writeLog({
              Evento: "INVENTARIO_SALIDA_CREATE",
              Mensaje: `Documento de salida creado: ${datos.Folio || targetId || ""}`.trim(),
              reference: { id: targetId, tp: "INV-SalidaMercancia", al: datos.Folio || "SALIDA INVENTARIO" },
              data: datos
            });
            this.$swal({
              title: "Guardado",
              text: "El documento se guardo corretamente",
              icon: "success",
            });
            this.$router.push({
              path:
                "/productos-inventarios/documentoSalida/" +
                result.value.data.data.Id,
            });
            if (sendInv) {
              this.sendInventario();
            }
          } else {
            this.$swal(
              "Error saving Categoria",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    editDocument(datos, sendInv) {
      let editData = {
        Id: this.$route.params.idDocumento,
        Productos: [],
        TipoMovimiento: "Salida",
        Origen: this.Origen,
      };
      let prod = [];
      datos.Productos.forEach((element) => {
        prod.push({
          Id: element.Id,
          Nombre: element.Nombre,
          Factura: element.Factura,
          Cantidad: parseInt(element.Cantidad),
          Precio: parseFloat(element.Precio),
          Moneda: element.Moneda,
          Motivo: element.Motivo,
        });
      });

      editData.Productos = prod;

      this.$pgsHelper.log(editData);

      this.$swal({
        title: "¿Deseas modificar este documento con los productos indicados?",
        text: "Se modificara el documento y sus productos indicados ",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("ProShop-Inventario-editarPreInventario", editData)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$pgsHelper.writeLog({
              Evento: "INVENTARIO_SALIDA_EDIT",
              Mensaje: `Documento de salida editado: ${editData.Id}`,
              reference: { id: editData.Id, tp: "INV-SalidaMercancia", al: "SALIDA INVENTARIO" },
              data: editData
            });
            this.$swal({
              title: "Guardado",
              text: "El documento se guardo corretamente",
              icon: "success",
            });
            //this.$router.push({path:'/productos-inventarios/documentoRecepcion/'+result.value.data.data.Id});
            if (sendInv) {
              this.sendInventario();
            }
          } else {
            this.$swal(
              "Error saving Documentos",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    async getProdDoc() {},
  },
  computed: {
    origenes() {
      let ori = this.$store.getters.getCentrosConsumo;
      return ori;
    },
    data_hotel() {
      let data = [];
      this.hoteles.forEach((htl) => {
        let hotel = {
          id: htl.id,
          nombre: htl.Nombre,
          transportacion: htl.TransportacionActivada
            ? htl.TransportacionActivada
            : false,
          PrecioRT: htl.PrecioRT ? htl.PrecioRT : 0,
          PrecioOWGH: htl.PrecioOWGH ? htl.PrecioOWGH : 0,
          PrecioOWHG: htl.PrecioOWHG ? htl.PrecioOWHG : 0,
        };

        data.push(hotel);
      });

      return data;
    },
  },
  watch: {},
  mounted() {},
  created() {
    this.MainDepartamento = localStorage.getItem("selectedDepartment");
    if (this.$route.params.idDocumento) {
      // this.title = "Edición de documento : " + this.$route.params.idDocumento;
      this.getDocumentInfo(this.$route.params.idDocumento);
    } else {
      this.Origen = this.origenes[0] ? this.origenes[0].id : "";
    }
    this.getProdDoc();
  },
};
</script>
